import dayjs, { Dayjs } from 'dayjs'
import { round } from './math'

const vatSwapDay = dayjs().year(2024).month(8).startOf('month')

export const addVat = (price: number, date: Dayjs = dayjs()) => {
    const vatMultiplier = date.isAfter(vatSwapDay) ? 1.255 : 1.24
    return price * vatMultiplier
}

export const priceString = (price: number, decimalPlaces = 2) => {
    return round(price, decimalPlaces).toFixed(decimalPlaces).replace('.', ',')
}
